module.exports = __webpack_public_path__ + "assets/img/Logo-SB.cbb2f201.png";